module.exports = __webpack_public_path__ + "img/expovina_09(1).f43d2721.jpg";